import { styled } from '../../../../../utils/styled';
import { propStyles } from '../../../../../utils/propStyles';

const StyledComponent = styled<any, any>(
    'div',
    'toastWrapper',
    'feedback-toaster'
)`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    margin: '5px',
    height: '38px',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Feedback/Components/Toaster/StyledComponents/ToastWrapper.tsx